document.addEventListener('turbolinks:load', () => {
    const guidedTourSelectPreview = document.getElementById('guidedTourSelectPreview')
    const guideGuestPreviewScreen = document.getElementById('guideGuestPreviewScreen')
    const sgScreen = document.getElementById('sgScreen')

    const tourScrollList = document.getElementById('tourScrollList')
    const guestPreviewArea = document.getElementById('guestPreviewArea')
    const guideTourListTopBar = document.getElementById('guideTourListTopBar')
    let richTextAreas

    const guidePreviewDetailedWebsite = document.getElementById('guidePreviewDetailedWebsite')
    const guidePreviewDetailedWebsiteHolder = document.getElementById('guidePreviewDetailedWebsiteHolder')


    if (guidedTourSelectPreview !== null && sgScreen !== null && guideGuestPreviewScreen !== null && tourScrollList !== null) {
        richTextAreas = sgScreen.getElementsByClassName("trix-content")
        resize()
        handleScroll()
    }

    function resize() {
        let resizeObserver = new ResizeObserver(() => {
            const currentSgScreenHeight = sgScreen.getBoundingClientRect().height
            const guestPreviewHeight = guideGuestPreviewScreen.getBoundingClientRect().height

            // trix
            for (let richTextArea of richTextAreas) {

                //TODO: prüfen ob textgröße angepasst werden muss
                if (richTextArea.parentNode.classList.contains('guideGuestPreviewDetailedText')) {
                    // guide guest preview
                    richTextArea.style.fontSize = `${guestPreviewHeight / 20}px`
                    richTextArea.style.lineHeight = `${guestPreviewHeight / 14}px`
                    const h1s = richTextArea.getElementsByTagName('h1')
                    for (let h1 of h1s) {
                        h1.classList.add('font-bold')
                        h1.style.fontSize = `${guestPreviewHeight / 14}px`
                    }
                } //other case can only appear in station_detail_screen.js
            }

            if (guidePreviewDetailedWebsite !== null && guidePreviewDetailedWebsiteHolder !== null) {
                resizeIframe()
            }
        })
        resizeObserver.observe(sgScreen);
    }

    function resizeIframe() {
        const guestPreviewHeightScale = guidePreviewDetailedWebsiteHolder.getBoundingClientRect().height/5.684438040345821
        guidePreviewDetailedWebsite.style.transform = `scale(${guestPreviewHeightScale}%)`
        guidePreviewDetailedWebsite.style.transformOrigin = '0 0'
        guidePreviewDetailedWebsite.style.height = `${1/(guestPreviewHeightScale/100) * 100}%`
    }

    function handleScroll() {
        tourScrollList.addEventListener("scroll", (e) => {
            if (tourScrollList.scrollTop === 0) {
                guideTourListTopBar.classList.remove('bg-mediumLightBlueGuideUi')
                guideTourListTopBar.classList.add('bg-extraLightGrayGuideUi')
            } else {
                guideTourListTopBar.classList.add('bg-mediumLightBlueGuideUi')
                guideTourListTopBar.classList.remove('bg-extraLightGrayGuideUi')
            }

        });
    }
})